import type React from 'react';

/** @deprecated Use icons from icons-v2-generated instead. */
export const VendorShowcaseMainIcon = ({ className }: { className?: string }) => (
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M25 74.5C24.7239 74.5 24.5 74.7239 24.5 75C24.5 75.2761 24.7239 75.5 25 75.5V74.5ZM175 75.5C175.276 75.5 175.5 75.2761 175.5 75C175.5 74.7239 175.276 74.5 175 74.5V75.5ZM83.6869 106.604C83.8821 106.408 83.8821 106.092 83.6869 105.896C83.4916 105.701 83.175 105.701 82.9798 105.896L83.6869 106.604ZM64.5833 125L64.2298 124.646C64.0345 124.842 64.0345 125.158 64.2298 125.354L64.5833 125ZM82.9798 144.104C83.175 144.299 83.4916 144.299 83.6869 144.104C83.8821 143.908 83.8821 143.592 83.6869 143.396L82.9798 144.104ZM117.02 105.896C116.825 105.701 116.508 105.701 116.313 105.896C116.118 106.092 116.118 106.408 116.313 106.604L117.02 105.896ZM135.417 125L135.77 125.354C135.864 125.26 135.917 125.133 135.917 125C135.917 124.867 135.864 124.74 135.77 124.646L135.417 125ZM116.313 143.396C116.118 143.592 116.118 143.908 116.313 144.104C116.508 144.299 116.825 144.299 117.02 144.104L116.313 143.396ZM25 75V75.5H175V75V74.5H25V75ZM150 175V174.5H50V175V175.5H150V175ZM25 150H25.5V50H25H24.5V150H25ZM175 50H174.5V150H175H175.5V50H175ZM50 25V25.5H150V25V24.5H50V25ZM175 50H175.5C175.5 35.9167 164.083 24.5 150 24.5V25V25.5C163.531 25.5 174.5 36.469 174.5 50H175ZM25 50H25.5C25.5 36.469 36.469 25.5 50 25.5V25V24.5C35.9167 24.5 24.5 35.9167 24.5 50H25ZM50 175V174.5C36.469 174.5 25.5 163.531 25.5 150H25H24.5C24.5 164.083 35.9167 175.5 50 175.5V175ZM150 175V175.5C164.083 175.5 175.5 164.083 175.5 150H175H174.5C174.5 163.531 163.531 174.5 150 174.5V175ZM83.3333 106.25L82.9798 105.896L64.2298 124.646L64.5833 125L64.9369 125.354L83.6869 106.604L83.3333 106.25ZM64.5833 125L64.2298 125.354L82.9798 144.104L83.3333 143.75L83.6869 143.396L64.9369 124.646L64.5833 125ZM116.667 106.25L116.313 106.604L135.063 125.354L135.417 125L135.77 124.646L117.02 105.896L116.667 106.25ZM135.417 125L135.063 124.646L116.313 143.396L116.667 143.75L117.02 144.104L135.77 125.354L135.417 125Z"
      fill="#F357BB"
    />
  </svg>
);

interface TransparentTrustedIconProps {
  className?: string;
  color?: string;
  size?: number;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const TransparentTrustedIcon: React.FC<TransparentTrustedIconProps> = ({
  className = '',
  color = '#F357BB',
  size = 42,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1.00001 22.9995H8.18141C9.30819 22.9995 10.4294 23.1582 11.5119 23.4709L17.7921 25.2852C18.5138 25.4937 19.2612 25.5995 20.0124 25.5995H24.5798C26.4024 25.5995 27.88 27.077 27.88 28.8997C27.88 30.2929 27.0167 31.4845 25.7959 31.9687M1.03468 34.9995H3.89475C4.56268 34.9995 5.21997 35.1667 5.80666 35.486L13.0165 39.4093C16.287 41.189 20.1636 41.4809 23.6637 40.2111L38.6966 34.7574C40.5154 34.0976 41.4538 32.0873 40.7916 30.2694C40.1306 28.4548 38.1248 27.5185 36.3093 28.1771L25.7959 31.9687M16.88 32.2H24.5798C24.9366 32.2 25.2802 32.1433 25.6021 32.0386M25.7959 31.9687L25.6021 32.0386M25.7959 31.9687C25.7322 31.9939 25.6676 32.0172 25.6021 32.0386M41.0039 18.9906H33.8225C32.6957 18.9906 31.5746 18.8318 30.492 18.5191L24.2118 16.7048C23.4902 16.4964 22.7427 16.3906 21.9915 16.3906H17.4242C15.6015 16.3906 14.1239 14.913 14.1239 13.0903C14.1239 11.6971 14.9872 10.5055 16.2081 10.0213M40.9692 6.99055H38.1092C37.4412 6.99055 36.784 6.82329 36.1973 6.50404L28.9874 2.5807C25.717 0.801024 21.8404 0.509084 18.3402 1.77887L3.30733 7.23258C1.48856 7.89241 0.550155 9.90272 1.21233 11.7206C1.87329 13.5352 3.87913 14.4716 5.69458 13.8129L16.2081 10.0213M25.1239 9.79006H17.4242C17.0673 9.79006 16.7237 9.8467 16.4018 9.95146M16.2081 10.0213L16.4018 9.95146M16.2081 10.0213C16.2717 9.99611 16.3363 9.97279 16.4018 9.95146"
      stroke={color}
    />
  </svg>
);

/** @deprecated Use icons from icons-v2-generated instead. */
export const ModularHellIcon = ({
  className,
  size = 38,
  color = '#5EFAF0',
}: {
  className?: string;
  size: number;
  color: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M30 24V30M30 30V36M30 30H24M30 30H36M26 15H34C35.6569 15 37 13.6569 37 12V4C37 2.34315 35.6569 1 34 1H26C24.3431 1 23 2.34315 23 4V12C23 13.6569 24.3431 15 26 15ZM4 37H12C13.6569 37 15 35.6569 15 34V26C15 24.3431 13.6569 23 12 23H4C2.34315 23 1 24.3431 1 26V34C1 35.6569 2.34315 37 4 37ZM4 15H12C13.6569 15 15 13.6569 15 12V4C15 2.34315 13.6569 1 12 1H4C2.34315 1 1 2.34315 1 4V12C1 13.6569 2.34315 15 4 15Z"
      stroke={color}
    />
  </svg>
);

/** @deprecated Use icons from icons-v2-generated instead. */
export const RapidInnovationIcon = ({
  className,
  size = 38,
  color = '#F357BB',
}: {
  className?: string;
  size: number;
  color: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 42 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M29.7959 1.38948L30.1924 1.6941V1.6941L29.7959 1.38948ZM15.1964 20.3921L14.7999 20.0875L15.1964 20.3921ZM25.861 23.1152L25.3642 23.0583V23.0583L25.861 23.1152ZM24.3976 35.8873L23.9009 35.8304L24.3976 35.8873ZM26.1841 36.6104L26.5806 36.915L26.1841 36.6104ZM40.7836 17.6077L41.1801 17.9124L40.7836 17.6077ZM30.119 14.8847L30.6158 14.9416L30.119 14.8847ZM31.5824 2.11255L32.0791 2.16946V2.16946L31.5824 2.11255ZM14 30.5001C14.2761 30.5001 14.5 30.2763 14.5 30.0001C14.5 29.724 14.2761 29.5001 14 29.5001V30.5001ZM4 29.5001C3.72386 29.5001 3.5 29.724 3.5 30.0001C3.5 30.2763 3.72386 30.5001 4 30.5001V29.5001ZM8 19.5001C8.27614 19.5001 8.5 19.2763 8.5 19.0001C8.5 18.724 8.27614 18.5001 8 18.5001V19.5001ZM1 18.5001C0.723858 18.5001 0.5 18.724 0.5 19.0001C0.5 19.2763 0.723858 19.5001 1 19.5001V18.5001ZM15 8.50015C15.2761 8.50015 15.5 8.27629 15.5 8.00015C15.5 7.72401 15.2761 7.50015 15 7.50015V8.50015ZM5 7.50015C4.72386 7.50015 4.5 7.72401 4.5 8.00015C4.5 8.27629 4.72386 8.50015 5 8.50015V7.50015ZM29.7959 1.38948L29.3994 1.08486L14.7999 20.0875L15.1964 20.3921L15.5929 20.6967L30.1924 1.6941L29.7959 1.38948ZM15.9893 22.0014V22.5014H24.8675V22.0014V21.5014H15.9893V22.0014ZM25.861 23.1152L25.3642 23.0583L23.9009 35.8304L24.3976 35.8873L24.8944 35.9442L26.3577 23.1721L25.861 23.1152ZM26.1841 36.6104L26.5806 36.915L41.1801 17.9124L40.7836 17.6077L40.3871 17.3031L25.7876 36.3058L26.1841 36.6104ZM39.9907 15.9985V15.4985H31.1125V15.9985V16.4985H39.9907V15.9985ZM30.119 14.8847L30.6158 14.9416L32.0791 2.16946L31.5824 2.11255L31.0856 2.05563L29.6223 14.8277L30.119 14.8847ZM31.1125 15.9985V15.4985C30.8138 15.4985 30.5818 15.2383 30.6158 14.9416L30.119 14.8847L29.6223 14.8277C29.5203 15.718 30.2165 16.4985 31.1125 16.4985V15.9985ZM40.7836 17.6077L41.1801 17.9124C41.9381 16.9258 41.2348 15.4985 39.9907 15.4985V15.9985V16.4985C40.4054 16.4985 40.6398 16.9743 40.3871 17.3031L40.7836 17.6077ZM24.3976 35.8873L23.9009 35.8304C23.7277 37.3414 25.654 38.121 26.5806 36.915L26.1841 36.6104L25.7876 36.3058C25.4788 36.7078 24.8367 36.4479 24.8944 35.9442L24.3976 35.8873ZM24.8675 22.0014V22.5014C25.1661 22.5014 25.3982 22.7615 25.3642 23.0583L25.861 23.1152L26.3577 23.1721C26.4597 22.2819 25.7635 21.5014 24.8675 21.5014V22.0014ZM15.1964 20.3921L14.7999 20.0875C14.0419 21.074 14.7452 22.5014 15.9893 22.5014V22.0014V21.5014C15.5746 21.5014 15.3402 21.0256 15.5929 20.6967L15.1964 20.3921ZM29.7959 1.38948L30.1924 1.6941C30.5012 1.2921 31.1433 1.55197 31.0856 2.05563L31.5824 2.11255L32.0791 2.16946C32.2522 0.658498 30.326 -0.121162 29.3994 1.08486L29.7959 1.38948ZM14 30.0001V29.5001H4V30.0001V30.5001H14V30.0001ZM8 19.0001V18.5001H1V19.0001V19.5001H8V19.0001ZM15 8.00015V7.50015H5V8.00015V8.50015H15V8.00015Z"
      fill={color}
    />
  </svg>
);

/** @deprecated Use icons from icons-v2-generated instead. */
export const LowerTCOIcon = ({
  className,
  size = 42,
  color = '#5EFAF0',
}: {
  className?: string;
  size: number;
  color: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M22.4752 39.0189L16.5669 33.2251M16.5669 33.2251C19.7959 31.6751 23.1472 29.3011 26.2241 26.2241M16.5669 33.2251C11.0188 35.8884 5.8316 36.1192 3.01651 33.3041M39.0188 22.4751L33.2251 16.5669M33.2251 16.5669C35.8884 11.0188 36.1192 5.83161 33.3041 3.01651M33.2251 16.5669C31.6751 19.7959 29.3011 23.1472 26.2241 26.2241M33.3041 3.01651C28.8506 -1.43701 18.4602 1.73282 10.0965 10.0965C1.73282 18.4602 -1.43701 28.8506 3.01651 33.3041M33.3041 3.01651L38.8322 9.15031C41.6473 11.9654 41.7193 16.8498 39.056 22.3978C37.506 25.6269 35.132 28.9781 32.055 32.0551M26.2241 26.2241L32.055 32.0551M3.01651 33.3041L9.15032 38.8322C11.9654 41.6473 16.8498 41.7193 22.3978 39.056C25.6269 37.506 28.9781 35.132 32.055 32.0551M28.1855 8.13608C30.5103 10.461 27.6721 16.5996 22.1354 22.1363C16.5987 27.673 10.4601 30.5112 8.13522 28.1863C5.81035 25.8615 8.64819 19.7225 14.1849 14.1858C19.7216 8.64905 25.8606 5.81121 28.1855 8.13608Z"
      stroke={color}
    />
  </svg>
);
